module.exports = __webpack_public_path__ + "static/media/gymnastics_icon-01.42983e06.png";